import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './SourceDeletePopup.css';
import NotebookLang from './NotebookLang.json';

class SourceDeletePopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			sourceID: 0,
		}
	}
		
	async componentDidMount() {
	}

	async componentDidUpdate() {
		
		var sourceID1 = this.state.sourceID;
		var sourceID2 = this.props.sourceID;
		
		if (sourceID2 === 0) {
			return;
		}

		if (sourceID1 === sourceID2) {
			return;
		}

		this.setState({
			sourceID: sourceID2,
		});
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickDeleteButton();
		}
	}

	onPopUpClosed() {
		this.props.setSourceDeletePopupYN(false);
	}

	onTitleChanged(value) {
		this.setState({title: value});
	}
	
	async serverDeleteSourceRecord(notebookID, sourceID, storageID, filename) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/deletesourcerecord?notebookid=" + notebookID;
		url = url + "&sourceid=" + sourceID;
		url = url + "&storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filename);
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
		}

		return responseText;
	}

	async onClickDeleteButton() {
		
		var notebookID = this.props.notebookID;
		var sourceID = this.state.sourceID;
		var notebookJsonObj = this.props.notebookJsonObj;
		var sourceJsonObj = this.props.sourceJsonObj;

		var storageID = notebookJsonObj.storageID;
		var filename = sourceJsonObj.filename;
		await this.serverDeleteSourceRecord(notebookID, sourceID, storageID, filename);

		var toastString = this.props.getLang(NotebookLang, "sourceRemoved");
		this.props.showToast(toastString);
		this.onPopUpClosed();
		this.props.refreshData();
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}
	
	renderContent() {

		var sourceJsonObj = this.props.sourceJsonObj;
		var filename = sourceJsonObj.filename;
		
		return (
			<div className="SourceDeletePopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="SourceDeletePopupTitle">{this.props.getLang(NotebookLang, "removeSource")}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				<div className="ViewContainer2">
					<fieldset className="SourceDeletePopupFieldset">
						<legend className="SourceDeletePopupLegend">{this.props.getLang(NotebookLang, "source")}</legend> 
						<input
							className="SourceDeletePopupInput" 
							disabled={true}
							id="title" 
							type="text" 
							value={filename}
							onChange={(event) => this.onTitleChanged(event.target.value)}
							onKeyDown={(event) => this.onKeyDown(event.keyCode)}
						/>
					</fieldset>
				</div>
				<div style={{height: "20px"}}></div>
				<div className="SourceDeletePopupWarining">{this.props.getLang(NotebookLang, "removeSourceWarning")}</div>
				<div style={{height: "30px"}}></div>
				<div className="ViewContainerButtons2">
					<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
					<div style={{width: "20px"}}></div>
					<button className="ViewSaveButton" onClick={() => this.onClickDeleteButton()}>{this.props.getLang(NotebookLang, "remove")}</button>
				</div>
				<div style={{height: "20px"}}></div>				
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="source-delete-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default SourceDeletePopup;

